(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcp-pad-quiz"] && !Shopify.designMode) return;
  try {
    
function initRcpQuizzes(){
document.querySelectorAll('.rcp-quiz').forEach(root=>{
if(root.dataset.ready)return;
root.dataset.ready='true';
const form=root.querySelector('form'), result=root.querySelector('.rcp-quiz__result'), catalog=JSON.parse(root.querySelector('.rcp-quiz__data').textContent);
form.addEventListener('submit',event=>{
event.preventDefault();
const answers=new FormData(form),goal=answers.get('goal'),feel=answers.get('feel'),budget=Number(answers.get('budget'));
let matches=catalog.filter(p=>p.available&&p.goal===goal);
if(!matches.length){result.hidden=false;root.querySelector('.rcp-quiz__name').textContent='Let’s find your fit together';root.querySelector('.rcp-quiz__match').hidden=true;result.focus();return;}
root.querySelector('.rcp-quiz__match').hidden=false;
matches.sort((a,b)=>((a.price<=budget?0:1)-(b.price<=budget?0:1))||((b.feel===feel?100:0)-(a.feel===feel?100:0))||a.price-b.price);
const picks=matches.slice(0,3);
root.querySelector('.rcp-quiz__name').textContent='Your practice pad options';
let list=root.querySelector('.rcp-quiz__options');
if(!list){list=document.createElement('div');list.className='rcp-quiz__options';root.querySelector('.rcp-quiz__match').after(list);}
list.replaceChildren();
const template=root.querySelector('.rcp-quiz__match');template.hidden=true;
root.querySelector('.rcp-quiz__designs').hidden=true;
picks.forEach((pick,index)=>{
const card=template.cloneNode(true);card.hidden=false;
const info=card.querySelector('div'),title=document.createElement('h4');title.textContent=pick.title;info.prepend(title);
card.querySelector('.rcp-quiz__reason').textContent=pick.reason;
const notice=[];
if(pick.price>budget)notice.push('Above your selected budget.');
if(pick.feel!==feel&&goal!=='tenor'&&goal!=='travel')notice.push('Compare the features: this option differs from your selected feel.');
if(goal==='tenor'||goal==='travel')notice.push('Prioritizes '+(goal==='tenor'?'a tenor layout':'portability')+' over snare-specific features.');
card.querySelector('.rcp-quiz__notice').textContent=notice.join(' ');
card.querySelector('.rcp-quiz__price').textContent='From '+pick.formatted;
const image=card.querySelector('.rcp-quiz__photo');image.src=pick.image;image.alt=pick.title;
card.querySelector('.rcp-quiz__shop').href=pick.url;
card.querySelector('.rcp-quiz__designs').hidden=pick.url.indexOf('flex-snare-practice-pad-12')===-1;
list.append(card);
});
result.hidden=false;result.focus();result.scrollIntoView({behavior:'smooth',block:'center'});
});
root.querySelector('.rcp-quiz__reset').addEventListener('click',()=>{result.hidden=true;form.querySelector('input').focus();form.scrollIntoView({behavior:'smooth',block:'start'});});
});
}
initRcpQuizzes();
document.addEventListener('shopify:section:load',initRcpQuizzes);

  } catch(e) { console.error(e); }
})();
})();
